module.exports = __webpack_public_path__ + "img/132.1c630d1f.jpg";